import {
  initSDK,
  sendXspmClick,
  sendXspmScan,
  trackEvent,
  // eslint-disable-next-line prettier/prettier
  utils
} from '@didi/webx-js'
import apiProxy from '@mpxjs/api-proxy'
import mpx from '@mpxjs/core'
import { getStyle } from '../editor/BaseForm'
import api from '../service'
import store, { pageStyle } from '../store'
import {
  chapter,
  formatPageConfig,
  getEnvParams,
  gotoLink,
  initLogin,
  trackEventLocate,
  // eslint-disable-next-line
  trackEventLogin
} from '../utils'

mpx.use(apiProxy, {
  usePromise: true,
})

const mixin = {
  data: {
    couponList: null,
    couponInfo: null,
    activityCouponInfo: null,
    popupResult: null,
    error: '',
    errmsg: '',
    hasCoupon: false,
    hasGetCoupon: false,
    doingGetCoupon: false,
    promotionType: '',
  },
  attached() {
    if (
      this.query.code &&
      this.query.state === window.sessionStorage.getItem('wxOauth')
    ) {
      window.sessionStorage.removeItem('wxOauth')
      this.getCoupon({}, false, false)
    }
  },
  watch: {
    initData: {
      handler(val) {
        if (!Object.keys(val).length) {
          return
        }
        this.init()
        trackEvent('userteam_fx_home_pg_sw', '展现')
        trackEventLocate()
        trackEventLogin()
      },
      immediate: true,
    },
  },
  computed: {
    ...store.mapGetters(['query', 'initData', 'cityInfo', 'PerfTrack']),
    warpStyle() {
      return getStyle(this.pageConfig.index.style)
    },
    ruleStyle() {
      return getStyle(this.pageConfig.rule.style)
    },
    btnStyle() {
      return getStyle(this.pageConfig.index.button.style)
    },
    btnText() {
      let text = ''
      if (this.hasGetCoupon && this.hasCoupon) {
        text = this.pageConfig.index.button.gotoText
      } else {
        text = this.pageConfig.index.button.text
      }
      return text
    },
  },
  methods: {
    init() {
      this.error = this.initData.group?.status !== 1 ? 1 : 0
      this.errmsg = this.initData.group?.status_desc
      this.activityCouponInfo =
        this.initData.activity_info?.rewards?.[0]?.coupon
      this.promotionType = this.initData.activity_info?.promotion_type
      // 点击按钮后登陆(小程序内嵌h5登陆之后会刷新页面)
      if (__mpx_mode__ === 'web') {
        this.query.is_back === '1' && this.getCoupon({}, false)
      }
      Promise.resolve().then(() => {
        // 为了让 editor/wyc/index.mpx的 attached先执行，给图片赋值
        this.perfTrackImage()
      })
    },
    perfTrackImage() {
      if (__mpx_mode__ === 'web') {
        let mainImage = ''
        if (this.initData.activity_info?.fe_style_version === 'sign_in') {
          mainImage =
            this.pageConfig.signVersion.index.style.backgroundImage.replace(
              /url\('(.*?)'\)/,
              '$1'
            )
        } else {
          mainImage =
            this.pageConfig.header?.image2 ||
            this.pageConfig.header?.image ||
            this.pageConfig.index.style.backgroundImage.replace(
              /url\('(.*?)'\)/,
              '$1'
            )
        }
        this.PerfTrack.coreImageReady({
          immediate: false,
          isKey: false,
          url: mainImage,
        })
        const resources = [mainImage]
        pageStyle[this.info.template]?.couponBg &&
          resources.push(pageStyle[this.info.template].couponBg)
        this.PerfTrack.customTTI({
          immediate: false,
          isKey: false,
          resources: resources,
        })
      }
    },
    // 领券后页面上的 按钮
    toUseCoupon(promotionType) {
      // 网约车的b端活动是自动跳转，不需要发
      const xspmInfo = {
        a: '',
        b: this.info.template,
        c: chapter[this.info.template].toUseBtn,
        d: '',
      }
      if (this.info.template !== 'wyc' || promotionType === 'personal') {
        trackEvent('userteam_fx_home_bt_ck', '“立即领取”按钮', {
          bt_text: this.btnText,
          action: 'qsy',
        })
        sendXspmClick({}, xspmInfo)
      }
      this.gotoLink(this.pageConfig.index.link, xspmInfo)
    },
    getCoupon: utils.debounce(
      async function (e, showLoading = true, wxOauth) {
        showLoading &&
          trackEvent('userteam_ddlm_coupon_bt_ck', '领券页面-按钮-点击')
        if (this.doingGetCoupon) return
        this.doingGetCoupon = true
        await initLogin({
          needLogin: true,
          wxOauth: wxOauth !== undefined ? wxOauth : this.info.wxOauth,
          redirectParams: {
            is_back: '1',
          },
        }).catch(e => {
          this.doingGetCoupon = false
          throw e
        })
        trackEvent('userteam_fx_home_bt_ck', '立即领取', {
          bt_text: this.btnText,
          action: 'ljlq',
        })
        showLoading &&
          mpx.showLoading({
            mask: true,
          })
        const envInfo = await getEnvParams(e)
        const res = await api.getCoupon({ env: envInfo })
        this.doingGetCoupon = false
        mpx.hideLoading()
        if (res.errno !== 0) {
          mpx.showToast({
            title: res.errmsg,
            icon: 'none',
            mask: true,
          })
        } else {
          this.popupShow(res.data)
        }
        await this.getRewardList()
        this.hasGetCoupon = true
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].toUseBtn,
            d: '',
          }
        )
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].couponToUseBtn,
            d: '',
          }
        )
      },
      800,
      true
    ),
    async getRewardList() {
      const res = await api.getRewardList()
      if (res.errno !== 0) {
        mpx.showToast({
          title: res.errmsg,
          icon: 'none',
          mask: true,
        })
        return
      }
      if (res.data?.rewards?.length) {
        this.couponList = res.data.rewards
        this.hasCoupon = true
      }
    },
    popupShow(data) {
      this.popupResult = data
      console.log('this.popupResult', this.popupResult)
      if (__mpx_mode__ === 'web') {
        window.document.body.style.height = '100vh'
        window.document.body.style.overflow = 'hidden'
        window.document.body.style.position = 'relative'
        window.document.documentElement.style.position = 'fixed'
      }
      sendXspmScan(
        {},
        {
          a: '',
          b: this.info.template,
          c: chapter[this.info.template].popupToUseBtn,
          d: '',
        }
      )
    },
    popupClick() {
      trackEvent('userteam_fx_dialog_bt_ck', '“领券弹窗-去使用”按钮')
      const xspmInfo = {
        a: '',
        b: this.info.template,
        c: chapter[this.info.template].popupToUseBtn,
        d: '',
      }
      sendXspmClick({}, xspmInfo)
      this.gotoLink(this.pageConfig.index.link, xspmInfo)
    },
    popupClose() {
      setTimeout(() => {
        this.popupResult = null
      }, 100)
      if (__mpx_mode__ === 'web') {
        window.document.body.style.height = '100%'
        window.document.body.style.overflow = 'auto'
        window.document.documentElement.style.position = 'static'
      }
    },
    // 单个券
    couponToUse(e) {
      const item = e.detail.item
      const batch_id = item.coupon?.batch_id
      trackEvent('userteam_fx_home_couponlist_re_ck', '券-去使用按钮', {
        batch_id: batch_id,
        bt_txt: item.coupon_txt,
      })
      const xspmInfo = {
        a: '',
        b: this.info.template,
        c: chapter[this.info.template].couponToUseBtn,
        d: '',
      }
      sendXspmClick({}, xspmInfo)
      this.gotoLink(item.link, xspmInfo)
    },
    gotoLink,
  },
}

if (process.env.MODE === 'editor') {
  mixin.attached = function () {
    // xpub编辑器用
    initSDK({ branch: 'passenger' })
    const res = require('../../editor/fenxiaoNy/model/props').mockIndex
    this.activityCouponInfo = res.data?.activity_info?.rewards?.[0]?.coupon
    this.couponInfo =
      res.data?.rewards?.[0]?.coupon ||
      res.data?.activity_info?.rewards?.[0]?.coupon
    this.couponInfo.tip = '最高'
    store.commit('setInitData', res.data)
    this.$watch('pageConfig', {
      handler: function (val) {
        formatPageConfig(this.pageConfig, this.info.template)
        if (['zc', 'gift'].includes(this.info.template)) {
          this.couponList = res.data.rewards
        }
        // wyc逻辑
        if (this.info.template === 'wyc') {
          if (this.pageConfig.result?.show || this.pageConfig.resultB?.show) {
            this.couponList = res.data.rewards
          }
          this.formatPageConfig && this.formatPageConfig()
          if (this.pageConfig.friday.mockEnable) {
            this.style = this.pageConfig.friday.style
            this.redPacketConfig.style = this.pageConfig.friday.redPacket.style
          }
        }
      },
      immediate: true,
      deep: true,
    })

    this.$watch('pageConfig.popup.showMock', function (val) {
      this.popupResult = val ? res.data : null
    })
  }

  // watch一个store中computed变量，在xpub侧会失效
  delete mixin.watch.initData
}

export default mixin
